import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Image,
  ResponsiveEmbed,
  Spinner,
} from "react-bootstrap";
import { FaGithub } from "react-icons/fa";
import { RiArrowRightSLine } from "react-icons/ri";

export default ({
  show,
  handleClose,
  name,
  video,
  image,
  summary,
  github,
  onLoad,
}) => {
  const [loading, setLoading] = useState(false);
  useEffect(() => setLoading(onLoad), [onLoad]);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && (
          <>
            <Spinner animation="border" variant="info" size="sm" />
            <span className="loading-text"> Please wait...</span>
          </>
        )}
        {video ? (
          <ResponsiveEmbed aspectRatio="16by9">
            <iframe
              src={video}
              className="embed-responsive-item"
              allow="fullscreen"
              title={name}
              onLoad={() => setLoading(false)}
            />
          </ResponsiveEmbed>
        ) : (
          <ResponsiveEmbed aspectRatio="4by3">
            <Image
              src={image}
              type="image/webp"
              fluid
              alt={name}
              onLoad={() => setLoading(false)}
            />
          </ResponsiveEmbed>
        )}
        <div style={{ textAlign: "justify", paddingTop: "2%" }}>
          <a
            href={github}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "black", textAlign: "right" }}
          >
            <FaGithub /> To GitHub <RiArrowRightSLine />{" "}
          </a>
          <br></br>
          {summary}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-info" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
